import { Component, OnInit } from '@angular/core';
import { NbToastrService, NbGlobalPhysicalPosition } from '@nebular/theme';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MyAccountService } from './my-account.service';

@Component({
  selector: 'ngx-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
})
export class MyAccountComponent implements OnInit {

  companyInfo: any = {};

  companyConfig: any = {};

  constructor(private toastrService: NbToastrService, private myAccountService: MyAccountService) {

  }

  ngOnInit() {
    this.myAccountService.findInfo().toPromise().then(result => {
      this.companyInfo = result.body;
    }).catch(err => {
      this.toastrService.show('Conta', 'Ocorreu um erro inesperado. :(',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });

    this.myAccountService.findConfig().toPromise().then(result => {
      if (result.body) {
        this.companyConfig = result.body;
      } else {
        this.companyConfig = {};
      }
    }).catch(err => {
      this.toastrService.show('Conta', 'Ocorreu um erro inesperado. :(',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

  updateConfig(event) {
    this.companyConfig.sendEmailBirthdayDate = event;
    this.myAccountService.updateCOnfig(this.companyConfig).toPromise().then(result => {
      this.companyConfig = result.body;
    }).catch(err => {
      this.toastrService.show('Conta', 'Ocorreu um erro inesperado. :(',
        { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
    });
  }

  // updateConfigOkr(event) {
  //   this.companyConfig.considerPercentOkrsPrincipal = event;
  //   this.myAccountService.updateCOnfig(this.companyConfig).toPromise().then(result => {
  //     this.companyConfig = result.body;
  //   }).catch(err => {
  //     this.toastrService.show('Conta', 'Ocorreu um erro inesperado. :(',
  //       { position: NbGlobalPhysicalPosition.TOP_RIGHT, status: 'danger' });
  //   });
  // }

}
